import React from 'react'
import API from 'utils/API'
import csrfToken from 'utils/csrfToken'
import Loader from 'components/utils/Loader'
import triggerEvent from 'utils/dataLayer'

class AptitudeCalculate extends React.Component {
  constructor(props) {
    super(props)
    this.state = { riasec_ratio_score: false }
  }

  componentDidMount() {
    triggerEvent('aptitude_complete')
    const answersParams = {
      R:  [],
      I:  [],
      A:  [],
      S:  [],
      E:  [],
      C:  [],
      EI: [],
      SN: [],
      TF: [],
      KE: [],
    }
    const answersStorage = JSON.parse(localStorage.getItem('aptitude_answers'))

    Object.keys(answersStorage).forEach((key) => {
      const factor = key.split('-').slice(-1)[0]
      const value = answersStorage[key]
      answersParams[factor].push(value)
    })

    const calculateAnswerPath = API.endPoints().aptitude.calculate_answer
    const options = {
      headers: {
        'X-CSRF-Token': csrfToken(),
      },
    }

    API.post(calculateAnswerPath, { answers: answersParams }, options).then((response) => {
      if (typeof localStorage !== 'undefined') {
        localStorage.removeItem('aptitude_answers')
        localStorage.removeItem('aptitude_page')
      }

      window.location = `/aptitude_test/recommendation/${response.data}`
    })
  }

  render() {
    return (
      <div id="AptitudeCalculate">
        <div className="loader-graph"><Loader /></div>
      </div>
    )
  }
}

export default AptitudeCalculate
